import type { FunctionComponent } from 'react'

import styles from './bento-rectangle-four-parts.module.scss'
import Part from './part'
import { Container } from '@components/layout/grid'
import type { BentoPieceRectangleFourPartsFragment } from '@graphql/fragments/BentoPieceRectangleFourPartsFragment.graphql'

export const BentoRectangleFourParts: FunctionComponent<Props> = ({
    copyOne,
    copyTwo,
    copyThree,
    copyFour,
}) => {
    return (
        <div className={styles.wrapper}>
            <Container className={styles.container}>
                <Part copy={copyOne} />
                <Part copy={copyTwo} />
                <Part copy={copyThree} />
                <Part copy={copyFour} />
            </Container>
        </div>
    )
}

export default BentoRectangleFourParts

type Props = Omit<BentoPieceRectangleFourPartsFragment, 'sys' | 'type'> & {
    index?: number
}
